interface CheckedProps {
  className: string;
  isEnabled: boolean;
}

export const CheckedIcon = ({ className, isEnabled }: CheckedProps) => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {isEnabled ? (
      <path
        d="M4.0983 7.22056L1.23114 4.35341L0 5.58455L4.0983 9.68285L12.55 1.23114L11.3189 0L4.0983 7.22056Z"
        fill="#22D9BB"
      />
    ) : (
      <path
        d="M4.0983 7.22056L1.23114 4.35341L0 5.58455L4.0983 9.68285L12.55 1.23114L11.3189 0L4.0983 7.22056Z"
        fill="#E6E6E6"
      />
    )}
  </svg>
);
